module.exports = __webpack_public_path__ + "58d2e8a989502324cc27744155ca1988.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-painter-s.png
// module id = 2884
// module chunks = 0